/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddLocationToProjectCommand } from '../../models/add-location-to-project-command';
import { AddLocationToProjectCommandResult } from '../../models/add-location-to-project-command-result';

export interface ApiProjectLocationsAddLocationToProjectPost$Params {
      body?: AddLocationToProjectCommand
}

export function apiProjectLocationsAddLocationToProjectPost(http: HttpClient, rootUrl: string, params?: ApiProjectLocationsAddLocationToProjectPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AddLocationToProjectCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectLocationsAddLocationToProjectPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AddLocationToProjectCommandResult>;
    })
  );
}

apiProjectLocationsAddLocationToProjectPost.PATH = '/api/ProjectLocations/AddLocationToProject';
